import Dropdown from "../utils/classes/Dropdown";

export default function (el) {
    const dropdown = new Dropdown(el);
    dropdown.run();
}
